import React, {useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API_URL from "../../functions/config";

const UpdateProduct = () => {
    const [name, setName] = React.useState('');
    const [price, setPrice] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [company, setCompany] = React.useState('');
    const [error, setError] = React.useState(false);
    const params = useParams();
    const navigate=useNavigate();

    //const userId = JSON.parse(localStorage.getItem('user'))._id;

    const getProductDetails = async () => {
        console.warn(params);
        let result = await fetch(`${API_URL}/product/${params.id}`,{
            headers:{
                authorization:`bearer ${JSON.parse(localStorage.getItem('token'))}`
            }
        });
        result = await result.json();
        setName(result.name)
        setPrice(result.price)
        setCategory(result.category)
        setCompany(result.company)
    }

    useEffect(() => {
        getProductDetails();
    }, []);

    const updateProduct = async () => {

        console.warn(name, price, category, company);

        let result = await fetch(`${API_URL}/product/${params.id}`,
            {
                method: 'PUT',
                body: JSON.stringify({ name, price, category, company }),
                headers: {
                    'Content-Type': 'application/json',
                    authorization:`bearer ${JSON.parse(localStorage.getItem('token'))}`
                },
            });

            result = await result.json();
            console.warn(result);
            navigate('/');

        console.warn(!name);
        if (!name || !price || !category || !company) {
            setError(true);
            return false;
        }

    }

    return (
        <div className='form_box'>
            <h1>Update Product</h1>

            <div className='form-group'>


                <input className='form-field' type='text' onChange={(e) => setName(e.target.value)} value={name} placeholder='Enter Product Name' />
                {error && !name && <span className="error_msg">Please Fill Product Name</span>}
                <input className='form-field' type='text' onChange={(e) => setPrice(e.target.value)} value={price} placeholder='Enter Product Price' />
                {error && !price && <span className="error_msg">Please Fill Product Price</span>}

                <input className='form-field' type='text' onChange={(e) => setCategory(e.target.value)} value={category} placeholder='Enter Product Category' />
                {error && !category && <span className="error_msg">Please Fill Product Category</span>}

                <input className='form-field' type='text' onChange={(e) => setCompany(e.target.value)} value={company} placeholder='Enter Product Company' />
                {error && !company && <span className="error_msg">Please Fill Product Company</span>}

                <button type='button' onClick={updateProduct} className='btn_main'>Update Product</button>


            </div>

        </div>
    )
}

export default UpdateProduct;